import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";

var Platform = function Platform(obj) {
  _classCallCheck(this, Platform);

  var is = obj.is,
      adapter = obj.adapter,
      log = obj.log,
      name = obj.name;
  Object.assign(this, obj, {
    is: is.test ? function () {
      return is.test(navigator.userAgent);
    } : is,
    log: typeof log === 'string' ? log : log ? name : 'other',
    adapter: adapter,
    name: name
  });
};

export { Platform as default };